import { DropDownButtonItemClickEvent } from "@progress/kendo-react-buttons";
import { intersection } from 'lodash';
import FilterListItemAbstract from "../../Abstract/Filter/FilterListItemAbstract";
import { FILTER } from "./Types";

class FilterListItem extends FilterListItemAbstract<{}, {}> {
  /**
   * Calls CallBack function with currentItem's properties from Props
   */
  editFilter = (itemData: any) => {
    this.dispatch('openEditFilterDialog', '', {
      dashboardFilter: true,
      filterData: itemData
    });
  };

  /**
   * Run callback function to trigger filter cloning
   */
  cloneFilter = (itemData: any) => {
    this.dispatch('openCloneFilterDialog', '', {
      dashboardFilter: true,
      filterData: itemData,
      createFilterTitle: this.translate('cloneFilter'),
    });
  };

  /**
   * Run callback function to trigger filter deleting
   */
  deleteFilter = () => {
    this.dispatch('deleteFilter', '', {
      filterIndex: this.props.currentItem.filterId
    })
  };

  /**
   * Override
   */
  handleItemClick = (itemData: any, event: DropDownButtonItemClickEvent) => {
    const { itemIndex } = event;
    switch (itemIndex) {
      case 0:
        this.cloneFilter(itemData);
        break;
      case 1:
        this.editFilter(itemData);
        break;
      case 2:
        this.deleteFilter();
        break;
      default:
        break;
    }
  };

  /**
  * @inheritdoc
  */
  handleEnterFromParent = (currentItem: FILTER) => {
    this.dispatch('openPrefilteredSubmissionList', '', {
      path: '/view/submissionList',
      filter: currentItem
    });
  }

  handleFilterClick = (event: any) => {
    const skippedClasses = ['tp-filter-list-item-count',
      'tp-filter-list-item-name',
      'tp-filter-list-item-wrap',
      'tp-filter-list-item-settings'];
    if (intersection(skippedClasses, event.target.classList).length) {
      const { currentItem } = this.props;
      delete currentItem.color;
      this.dispatch('openPrefilteredSubmissionList', '', {
        path: '/view/submissionList',
        filter: currentItem
      });
    }
  };
}

export default FilterListItem;
